var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "inner",
    { on: { apply: _vm.applyFilter, clear: _vm.clear } },
    [
      _vm._t(
        "default",
        _vm._l(_vm.options, function(option) {
          return _c("mobile-multiselect-item", {
            key: option.id,
            attrs: {
              title: option.label || option.value,
              "is-selected": _vm.isSelected(option)
            },
            nativeOn: {
              click: function($event) {
                return _vm.toggle(option)
              }
            }
          })
        }),
        { isSelected: _vm.isSelected, toggle: _vm.toggle, options: _vm.options }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }